import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import afshareimg from "../assets/images/af-share-img.svg";
import axiosInstance from "../api/axiosInstance";
import { getUserData, isAuthenticated } from "../utils/auth";

const ShareAffiliateLinkDialog = ({ open = false, onClose }) => {
  const authUser = useSelector((state) => state.auth?.user);
  const [userData, setUserData] = useState(() => {
    if (typeof window === "undefined") return null;
    return getUserData();
  });
  const isLoggedIn = typeof window !== "undefined" ? isAuthenticated() : false;
  const canAccess =
    isLoggedIn &&
    authUser &&
    typeof authUser?.is_demo === "boolean" &&
    authUser.is_demo !== true;

  return (
    <div className="login-component">
      <div className="modal-header bg-transparent border-0">
        <button type="button" className="btn-close" onClick={onClose}></button>
      </div>
      <div className="modal-body position-relative">
        <div className="share-link-img-sec">
          <img src={afshareimg} alt="af-share-img" className="w-100" />
        </div>
        <div className="af-share-link-wrapper">
          <p>Share Link</p>
          <div className="af-share-link-sec">
            <ShareLinkContent
              canAccess={canAccess}
              open={open}
              userData={userData}
            />
            <button
              className="thm-but btn-gradient"
              type="button"
              onClick={() => {
                // ShareLinkContent owns inviteLink state; if empty, do nothing.
                try {
                  if (!canAccess) return;
                  const el = document.getElementById(
                    "affiliate-invite-link-text",
                  );
                  const text = el?.textContent || "";
                  if (!text) return;
                  if (navigator.clipboard?.writeText) {
                    navigator.clipboard.writeText(text).then(
                      () => toast.success("Affiliate link copied to clipboard"),
                      () =>
                        toast.error("Unable to copy link. Please try again."),
                    );
                  } else {
                    const textarea = document.createElement("textarea");
                    textarea.value = text;
                    textarea.style.position = "fixed";
                    textarea.style.opacity = "0";
                    document.body.appendChild(textarea);
                    textarea.focus();
                    textarea.select();
                    document.execCommand("copy");
                    document.body.removeChild(textarea);
                    toast.success("Affiliate link copied to clipboard");
                  }
                } catch {
                  toast.error("Unable to copy link. Please try again.");
                }
              }}
            >
              Copy
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareAffiliateLinkDialog;

function ShareLinkContent({ open, canAccess, userData }) {
  const baseInviteDomain =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "https://usabet9.com";
  // const [inviteLink, setInviteLink] = useState("");
  const inviteLink = userData?.user_name
    ? `${baseInviteDomain}/signup?aff_code=${userData?.user_name}`
    : "";

  // useEffect(() => {
  //   let mounted = true;
  //   const fetchAffiliateCode = async () => {
  //     if (!open || !canAccess) {
  //       setInviteLink("");
  //       return;
  //     }

  //     try {
  //       const res = await axiosInstance.post("/report/getUserAffCode", {});
  //       const data = res?.data;
  //       if (res?.status && data?.affiliate_code) {
  //         const code = data.affiliate_code || "";
  //         const baseInviteDomain =
  //           typeof window !== "undefined" && window.location?.origin
  //             ? window.location.origin
  //             : "https://usabet9.com";
  //         setInviteLink(
  //           code ? `${baseInviteDomain}/signup?aff_code=${code}` : "",
  //         );
  //       } else {
  //         setInviteLink("");
  //       }
  //     } catch {
  //       if (mounted) setInviteLink("");
  //     }
  //   };

  //   fetchAffiliateCode();
  //   return () => {
  //     mounted = false;
  //   };
  // }, [open, canAccess]);

  return <span id="affiliate-invite-link-text">{inviteLink || ""}</span>;
}
